import { stockRequestBody } from "./stockContext";


import { apiFetch } from "./apiFetch";

export async function fetchStockBuyRecommendationFilters(serverUrl, stockSession) {
  const resp = await apiFetch(`${serverUrl}/listStockBuyRecommendationFilters`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession)),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to load buy list watchlists");
  }
  return {
    savedFilters: Array.isArray(data.savedFilters) ? data.savedFilters : [],
    aggregateCount: data.aggregateCount ?? 0,
  };
}

export async function saveStockBuyRecommendationFilter(serverUrl, stockSession, { name, yahooUrl, created_by }) {
  const resp = await apiFetch(`${serverUrl}/saveStockBuyRecommendationFilter`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession, { name, yahooUrl, created_by })),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to save buy list watchlist");
  }
  return data;
}

export async function deleteStockBuyRecommendationFilter(serverUrl, stockSession, filterId) {
  const resp = await apiFetch(`${serverUrl}/deleteStockBuyRecommendationFilter`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession, { filterId })),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to delete buy list watchlist");
  }
  return data;
}

export async function renameStockBuyRecommendationFilter(serverUrl, stockSession, { filterId, name }) {
  const resp = await apiFetch(`${serverUrl}/renameStockBuyRecommendationFilter`, {
    method: "POST",
    body: JSON.stringify(stockRequestBody(stockSession, { filterId, name })),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || "Failed to rename buy list watchlist");
  }
  return data;
}
